/******/ (() => { // webpackBootstrap
class CartQuantity extends HTMLElement {
  constructor() {
    super();
    this.removeButton = this.querySelector('[data-cart-remove-item]');
    this.adjustButtons = this.querySelectorAll('[data-cart-quantity-button]');
    this.input = this.querySelector('[data-cart-quantity-input]');
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.updateLineItem = this.updateLineItem.bind(this);
    this.updateCartCountIndicator = this.updateCartCountIndicator.bind(this);
    this.handleCartErrors = this.handleCartErrors.bind(this);
    this.setLoadingState = this.setLoadingState.bind(this);
    this.hideLoadingState = this.hideLoadingState.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-quantity'});
    this.removeButton?.addEventListener('click', this.handleRemoveItem);
    this.adjustButtons.forEach(button => button.addEventListener('click', this.handleButtonClick));
    this.input?.addEventListener('change', this.handleInputChange);
  }

  handleButtonClick(e) {
    /* ===== Handle the button click event ===== */
    e.preventDefault();
    const previousValue = this.input.value;
    const adjustment = e.currentTarget.name === 'plus' ? 1 : -1;

    // Adjust the quantity by the adjustment value
    this.adjustQuantity(adjustment);

    // Process the new quantity if quantity has changed
    if (previousValue !== this.input.value) {
      this.handleQuantityChange(this.input.value);
    }
  }

  adjustQuantity(adjustment) {
    /* ===== Adjust the quantity by the adjustment value ===== */
    const newValue = parseInt(this.input.value) + adjustment;
    // If the new value is not a number, set it to 1
    this.input.value = isNaN(newValue) ? 1 : newValue;

    // If the value is smaller than the min attribute, set it to the min attribute
    if (this.input.min && parseInt(this.input.value) < parseInt(this.input.min)) {
      this.input.value = this.input.min;
    }
  }

  handleInputChange(e) {
    /* ===== Handle the change event ===== */
    e.preventDefault();

    // If the value is not a number, set it to 1
    if (isNaN(this.input.value)) {
      this.input.value = 1;
    }

    // If the value is smaller than the min attribute, set it to the min attribute
    if (this.input.min && parseInt(this.input.value) < parseInt(this.input.min)) {
      this.input.value = this.input.min;
    }

    // Process the new quantity
    this.handleQuantityChange(this.input.value);
  }

  handleQuantityChange(inputValue) {
    /* ===== Update the cart with the new quantity ===== */
    const quantity = parseInt(inputValue);
    this.updateCart(this.itemIndex, quantity);
  }

async handleRemoveItem() {
  // debugger
    /* ===== Set quantity of line item to zero ===== */
    await this.updateCart(this.itemIndex, 0);

    /* ===== Handle the free gifts sequentially ===== */

}


async updateCart(line, quantity) {
    try {
        /* ===== Set the loading state ===== */
        this.setLoadingState();

        /* ===== Update the line item quantity ===== */
        let response = await this.updateLineItem(line, quantity);
        if (!response) return;


        /* ===== If successful response, re-render the cart ===== */
        window.eventBus.emit('update:cart:drawer', response);

        /* ===== Update cart count ===== */
        this.updateCartCountIndicator();
    } catch (error) {
        console.error('Error updating cart:', error);
    } finally {
        this.hideLoadingState();
    }
}





  async updateLineItem(line, quantity) {
    try {
      /* ===== Update line item quantity ===== */
      const body = JSON.stringify({
        line,
        quantity,
        sections: 'cart-drawer'
      });

      const response = await fetch(window.routes.cart_change_url, { 
        ...this.fetchConfig(),
        body
      });

      const responseText = await response.text();

      if (!responseText) {
        this.handleCartErrors();
        return null;
      }

      const parsedResponse = JSON.parse(responseText);

      /* ===== Handle errors ===== */
      if (parsedResponse.errors) {
        this.handleCartErrors(line, parsedResponse.errors);
        return null;
      }

      return parsedResponse;
    } catch (error) {
      console.error('Error updating cart line item:', error);
    }
  }

  fetchConfig(type = 'json') {
    /* ===== Create the fetch configuration object ===== */
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  handleCartErrors(line, errors) {
    /* ===== Reset loading state and input value ===== */
    this.hideLoadingState();
    this.input.value = this.input.getAttribute('value');

    /* ===== Display the error message ===== */
    this.renderErrorMessage(line, errors);
  }

  renderErrorMessage(line, message) {
    /* ===== Display the error message ===== */
    const errorElement = document.querySelector(`[data-cart-error-index="${line}"]`);
    if (!errorElement) return;
    errorElement.innerHTML = message;
    errorElement.setAttribute('aria-hidden', false);

    /* ===== If we're at the bottom of the cart, scroll error message into view ===== */
    const isLastItem = errorElement.getAttribute('data-cart-is-last-item') === 'true';
    if (isLastItem) {
      errorElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  async getCart() {
    /* ===== Fetch the cart information ===== */
    try {
      const response = await fetch(`${window.routes.cart_url}?view=compare`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.description || error.message}`);
    }
  }

 updateCartCountIndicator() {
  /* ===== Update the cart count indicator ===== */
  if (!this.cartCountIndicator) return;
  
  this.getCart().then(cart => {
    window.wetheme.updateCartCount(cart);
    let totalPrice = cart.total_price;
      if (document.querySelectorAll('.cart-freeshipping-line').length > 0) {
    document.querySelectorAll('.cart-freeshipping-line').forEach((item) => {
      if (item.dataset.shipping) {
        let freeShippingThreshold = Number(item.dataset.shipping); 
        let leaveMoney = 0;
        let percentLeave = 0;
        debugger
        if (totalPrice < freeShippingThreshold * 100) { 
          leaveMoney = (freeShippingThreshold - totalPrice / 100).toFixed(2);
          percentLeave = (totalPrice / (freeShippingThreshold * 100)) * 100;
          item.querySelector('.cart-freeshipoing-indicator-line').style.left = `${percentLeave - 100}%`;
          item.classList.remove('free-get');
        } else {
          item.querySelector('.cart-freeshipoing-indicator-line').style.left = '0';
          item.classList.add('free-get');
          leaveMoney = 0;
        }


        item.querySelector('.cart-freeshipping-price').innerHTML = `${currencyIso_code}${leaveMoney}`;
      }
    });
  }
  });
}

  getGiftWrapLine(cart) {
    return cart.items.findIndex(item => item.variant_id === this.giftWrapVariantId) + 1 || null;
  }

  getGiftWrapQuantity(cart) {
    return cart.items.find(item => item.variant_id === this.giftWrapVariantId)?.quantity || null;
  }

  setLoadingState() {
    this.classList.add('is-loading');
  }

  hideLoadingState() {
    this.classList.remove('is-loading');
  }

  get itemIndex() {
    return parseInt(this.getAttribute('data-item-index'));
  }

  get previousQuantity() {
    return parseInt(this.getAttribute('data-item-quantity'));
  }

  get hasGiftWrap() {
    return this.getAttribute('data-has-gift-wrap') === "true";
  }

  get giftWrapVariantId() {
    return parseInt(this.getAttribute('data-gift-wrap-variant-id'));
  }
}

customElements.define('cart-quantity', CartQuantity);
/******/ })()
;



var Shopify = Shopify || {};
if (typeof currencyIso_code !== 'undefined') {
  if (currencyIso_code == '') {
    currencyIso_code = '$';
  }
} else {
  var currencyIso_code = '$';
}
if (typeof cartAmout !== 'undefined') {
  if (cartAmout == '') {
    cartAmout = '{{amount}}';
  }
} else {
  var cartAmout = '{{amount}}';
}

Shopify.money_format = cartAmout;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return '0'; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Free delivery price count
function drawerFreeDelveryLine(totalPrice) {
  if (document.querySelectorAll('.cart-freeshipping-line').length > 0) {
    document.querySelectorAll('.cart-freeshipping-line').forEach((item) => {
      if (item.dataset.shipping) {
        let freeShippingThreshold = Number(item.dataset.shipping); 
        let leaveMoney = 0;
        let percentLeave = 0;
    
        if (totalPrice < freeShippingThreshold * 100) { // convert threshold to cents
          leaveMoney = (freeShippingThreshold - totalPrice / 100).toFixed(2);
          percentLeave = (totalPrice / (freeShippingThreshold * 100)) * 100;
          item.querySelector('.cart-freeshipoing-indicator-line').style.left = `${percentLeave - 100}%`;
          item.classList.remove('free-get');
        } else {
          item.querySelector('.cart-freeshipoing-indicator-line').style.left = '0';
          item.classList.add('free-get');
          leaveMoney = 0;
        }
  
        // Update the remaining amount needed for free shipping
        item.querySelector('.cart-freeshipping-price').innerHTML = `${currencyIso_code}${leaveMoney}`;
      }
    });
  }
}

// Initial page load to show free shipping status
function fetchCart() {
  fetch(`/cart/update`, {
    method: 'POST',
    headers: {'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest'}
  })
  .then(response => response.json())
  .then(cart => {

    drawerFreeDelveryLine(cart.total_price);
  });
}

fetchCart();


document.addEventListener("DOMContentLoaded", () => {
    const removeButtons = document.querySelectorAll(".cart__page_mn .cart__remove");

    removeButtons.forEach((button) => {
        button.addEventListener("click", async (event) => {
            event.preventDefault(); // Prevent default link behavior

            const href = button.getAttribute("href");
            const urlParams = new URLSearchParams(href.split("?")[1]);
            const line = urlParams.get("line");

            if (line) {
                try {
                    // Call Shopify Cart API to remove the item
                    await fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            line: parseInt(line),
                            quantity: 0,
                        }),
                    });

                    // Optionally refresh the cart drawer or page
                    location.reload(); // Refresh to update cart UI
                } catch (error) {
                    console.error("Error removing item or handling free gifts:", error);
                }
            } else {
                console.error("Line parameter is missing in the URL.");
            }
        });
    });
});





function refreshCartDrawer() {
    const cartDrawerContent = document.querySelector('.global-drawer__content');

    // Add loading class before fetching the data
    cartDrawerContent.classList.add('loading');

    // Fetch cart data
    jQuery.getJSON('/cart.js', function (cart) {
        // Update the cart drawer sections dynamically
        eventBus.emit('update:cart:drawer', { sections: { 'cart-drawer': cart } });
        eventBus.emit('render:cart:drawer', { sections: { 'cart-drawer': cart } });

        // Remove loading class once data is rendered
        setTimeout(() => {
            cartDrawerContent.classList.remove('loading');
        }, 1000); // Optional delay for smooth transition
    });
}


function setCartDrawerLoadingState() {
    const cartDrawer = document.querySelector('.cart-drawer__body');
    if (cartDrawer) {
        cartDrawer.innerHTML = `<div class="loading-state">Loading...</div>`;
    }
}

function clearCartDrawerLoadingState() {
    const loadingState = document.querySelector('.cart-drawer__body .loading-state');
    if (loadingState) {
        loadingState.remove();
    }
}

